export enum LevelEnum {
  BEGINNER = 5,
  CONFIRMED = 10,
  EXPERT = 20,
}
